export const LAST_SEEN_KEY = "dawn.lastSeenVersion";

function getLastSeenVersion(): string | null {
  return localStorage.getItem(LAST_SEEN_KEY);
}

export function markVersionSeen(version: string): void {
  localStorage.setItem(LAST_SEEN_KEY, version);
}

export function hasUnseenRelease(latestVersion: string): boolean {
  return getLastSeenVersion() !== latestVersion;
}
